module.exports = __webpack_public_path__ + "img/banner.5813102.png";